module.exports = __webpack_public_path__ + "img/shandian_ceshi.eef46e0b.png";